import(/* webpackMode: "eager" */ "/usr/src/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/usr/src/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/usr/src/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/usr/src/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/src/app/ClientLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreProvider"] */ "/usr/src/src/providers/StoreProvider.tsx");
